














































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseModal from '@/jbi-shared/vue-components/BaseModal.vue';
import { cloneDeep as _cloneDeep } from 'lodash';
import {
  AuditSamplingSite,
  CalculateData,
} from '@/store/modules/audits/types/audits.types';

@Component({
  components: {
    BaseModal,
  },
})
export default class ConsecutiveCalculator extends Vue {
  @Prop()
  public initialData!: any;
  @Prop()
  public siteArray!: AuditSamplingSite[];
  @Prop()
  public siteName!: string;
  @Prop()
  public criteriaTitle!: string;
  @Prop()
  public auditSiteId!: number;
  @Prop()
  public auditCriteriaId!: number;

  public modalTitle: string = 'Set Consecutive Sample Size';
  public modalSize: string = 'large';
  public calculateData: any = {
    output: 0,
  };
  public isCriteriaBasedMultiSiteSampling = false;
  public isDisableInput: boolean = true;

  public mounted() {
    if (this.initialData) {
      this.calculateData = _cloneDeep(this.initialData);
    }

    if (this.siteArray) {
      this.isCriteriaBasedMultiSiteSampling = true;
      this.updateChildSamplingSize();
    }
  }

  public handleCloseButton(closeModal: any) {
    closeModal();
  }

  public handleApplySampleSize(closeModal: any) {
    let emitData: any = this.calculateData;
    if (this.auditSiteId !== undefined) {
      emitData = {
        ...emitData,
        auditSiteId: this.auditSiteId,
      };
    }

    if (this.auditCriteriaId !== undefined) {
      emitData = {
        ...emitData,
        auditCriteriaId: this.auditCriteriaId,
      };
    }
    this.$emit('applySampleSize', emitData);
    closeModal();
  }

  public updateChildSamplingSize() {
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      const parentVal = this.calculateData.output;
      const siteArrayLength = this.siteArray.length;
      const modulo = parentVal % siteArrayLength;
      const childVal = (parentVal - modulo) / siteArrayLength;
      this.calculateData.sites.forEach(
        (currentVal: AuditSamplingSite, siteIndex: number) => {
          currentVal.calculateData.output =
            siteIndex === 0 ? childVal + modulo : childVal;
        },
      );
    }
  }

  public updateOtherChildSamplingSize(siteIndex: number) {
    if (
      this.siteArray !== undefined &&
      this.calculateData.sites !== undefined
    ) {
      const currentElementVal = !this.calculateData.sites[siteIndex]
        .calculateData.output
        ? 0
        : Number(this.calculateData.sites[siteIndex].calculateData.output);
      const parentVal: number = !this.calculateData.output
        ? 0
        : Number(this.calculateData.output);
      if (parentVal < currentElementVal) {
        this.updateChildSamplingSize();
      } else {
        const tempParentVal = parentVal - currentElementVal;
        const siteArrayLength = Number(this.siteArray.length - 1);
        const modulo = tempParentVal % siteArrayLength;
        const childVal = (tempParentVal - modulo) / siteArrayLength;
        this.calculateData.sites.forEach(
          (currentVal: AuditSamplingSite, currentSiteIndex: number) => {
            if (currentSiteIndex !== siteIndex && siteIndex !== 0) {
              currentVal.calculateData.output =
                currentSiteIndex === 0 ? childVal + modulo : childVal;
            } else if (currentSiteIndex !== siteIndex) {
              currentVal.calculateData.output =
                currentSiteIndex === 1 ? childVal + modulo : childVal;
            }
          },
        );
      }
    }
  }

  @Watch('calculateData', { deep: true })
  public onCheckCalculateData(value: any) {
    if (value.sites) {
      this.isDisableInput = Number(value.output) !== 0 ? false : true;
    }
  }
}
